import _ from 'lodash';
import { intialMessage, userMesaageType } from 'constants/ui.constants';
import {
	setAltshulerAccounts,
	setExistingBankAccounts,
	setLoading,
	setMessage,
	getExistingBankAccounts,
} from 'state/reducers/bank-account.reducers';
import API from 'services/api.services';
import {
	API_GET_COMPANY_ALTSHULER_ACCOUNTS,
	API_GET_COMPANY_BANK_ACCOUNTS,
	API_ADD_BANK_ACCOUNT,
} from 'constants/db.constants';
import { BankAccount } from 'constants/bank-account.constants';
import { store } from 'state/store';
import { UserPermission } from 'constants/user.constants';
import { AddBankFields } from 'constants/settings.constants';
import { setErrorMessage } from 'utils';

export function getBankAccountsByCompanyId() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		const paramsSetting = {
			companyId: store.getState().user.details?.companyId,
		};

		await API.getInstance()
			.get(API_GET_COMPANY_BANK_ACCOUNTS, paramsSetting)
			.then((response) => {
				const bankAccounts: BankAccount[] = response.data.bankAccounts;
				dispatch(setExistingBankAccounts(bankAccounts));
				dispatch(setLoading(false));
			})
			.catch((error) => {
				setTimeout(() => {
					dispatch(setLoading(false));
					dispatch(setExistingBankAccounts([]));
					setErrorMessage(setMessage, error);
				}, 500);
			});
	};
}

export function getAltshulerAccountsByCompanyId() {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		const paramsSetting = {
			companyId: store.getState().user.details?.companyId,
		};

		await API.getInstance()
			.get(API_GET_COMPANY_ALTSHULER_ACCOUNTS, paramsSetting)
			.then((response) => {
				const bankAccounts: BankAccount[] = response.data.altshulerAccounts;
				const modifiedAccounts = bankAccounts.map((account) => {
					return {
						...account,
						bankName: account.bank,
						bankNumber: account.bank.bankCode,
					};
				});
				dispatch(setLoading(false));
				dispatch(setAltshulerAccounts(modifiedAccounts));
			})
			.catch((error) => {
				setTimeout(() => {
					dispatch(setLoading(false));
					dispatch(setAltshulerAccounts([]));
					setErrorMessage(setMessage, error);
				}, 500);
			});
	};
}

export function addBankAccount(
	accountOwnerName: string,
	accountNumber: string,
	branchNumber: string,
	bankId: number,
	file: File
) {
	return async (dispatch: any) => {
		dispatch(setLoading(true));
		dispatch(setMessage(intialMessage));
		const formData = new FormData();
		formData.append('companyId', String(store.getState().user.details?.companyId));
		formData.append(AddBankFields.BANK_ACCOUNT_HOLDER_NAME, String(accountOwnerName));
		formData.append(AddBankFields.ACCOUNT_NUMBER, String(accountNumber));
		formData.append(AddBankFields.BRANCH_NUMBER, String(branchNumber));
		formData.append(AddBankFields.BANK_ID, String(bankId));
		formData.append('isSigned', String(_.isEqual(store.getState().user.userPermission, UserPermission.SIGNER)));
		if (file) {
			formData.append('file', file, file.name);
		}
		await API.getInstance()
			.post(API_ADD_BANK_ACCOUNT, formData)
			.then((response) => {
				dispatch(setLoading(false));
				dispatch(
					setMessage({
						exist: false,
						type: userMesaageType.SUCCESS,
					})
				);
			})
			.catch((error) => {
				setTimeout(() => {
					dispatch(setLoading(false));
					///dispatch(setExistingBankAccounts([]));
					setErrorMessage(setMessage, error);
				}, 500);
			});
	};
}

export function getDigitalDepositBankAccountsAvailabilitySummary() {
	const bankAccounts: BankAccount[] = getExistingBankAccounts(store.getState());

	const supportedDigitalDepositBankAccounts = bankAccounts.filter((bankAccount) => {
		return bankAccount.bankName.isDigitalDepositSupported === true;
	});

	const availableDigitalDepositBankAccounts = supportedDigitalDepositBankAccounts.filter((bankAccount) => {
		return bankAccount.bankName.isDigitalDepositTemporarilyUnavailable !== true;
	});

	const temporarilyUnavailableDigitalDepositBankAccounts = supportedDigitalDepositBankAccounts.filter((bankAccount) => {
		return bankAccount.bankName.isDigitalDepositTemporarilyUnavailable === true;
	});

	const temporarilyUnavailableDigitalDepositBankNames = _.uniq(
		temporarilyUnavailableDigitalDepositBankAccounts.map((bankAccount) => _.trim(bankAccount.bankName.bankName))
	);

	return {
		supportedDigitalDepositBankAccounts,
		availableDigitalDepositBankAccounts,
		temporarilyUnavailableDigitalDepositBankAccounts,
		temporarilyUnavailableDigitalDepositBankNames,
	};
}
